import request from './http';

// 查询菜单树形列表
export const getMenuList = data => {
    return request({
        // url: '/auth/sysMenu/findTreeMenuList?companyId='+data.companyId+"&menuName="+data.menuName,
        url: '/auth/sysMenu/findTreeMenuList?companyId='+data.companyId+"&menuName=",
        method: 'get',
    })
}

// 修改菜单信息
export const updateMenuData =data => {
    return request({
        url: '/auth/sysMenu/updateMenuList',
        method: 'put',
        data
    })
}

// 删除菜单信息
export const deleteMenuData = data => {
    return request({
        url: '/auth/sysMenu/deleteMenuById/'+data,
        method: 'delete',
    })
}

// 添加菜单信息
export const addMenuData = data => {
    return request({
        url: '/auth/sysMenu/addMenuList',
        method: 'post',
        data
    })
}

// 查询登陆用户的菜单权限
export const getAuthMenus = data => {
    return request({
        url: '/auth/sysMenu/selectUserAppAuthMenus?companyId=1',
        method: 'get',
    })
}
